export const secondsToTimeState = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return { hours, minutes, seconds };
};

export const timeStateToSeconds = (time) => {
    return (time.hours || 0) * 3600 + (time.minutes || 0) * 60 + (time.seconds || 0);
};

export const formatTimeStr = (totalSeconds, showMs = false) => {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = Math.floor(totalSeconds % 60);
    const ms = Math.round((totalSeconds - Math.floor(totalSeconds)) * 100);

    const hStr = h > 0 ? `${h}:` : "";
    const mStr = h > 0 ? m.toString().padStart(2, "0") : m.toString();
    const sStr = s.toString().padStart(2, "0");

    let res = `${hStr}${mStr}:${sStr}`;
    if (showMs) {
        res += `.${ms.toString().padStart(2, "0")}`;
    }
    return res;
};

export const formatPace = (secondsPerKm) => {
    if (!isFinite(secondsPerKm) || secondsPerKm <= 0) return "--:--";
    const m = Math.floor(secondsPerKm / 60);
    const s = Math.floor(secondsPerKm % 60);
    return `${m}'${s.toString().padStart(2, "0")}"`;
};

export const calculateStations = (totalDistanceKm) => {
    const stations = [];
    // First station at 5km
    let current = 5;
    while (current < totalDistanceKm) {
        stations.push(current);
        current += 2.5;
    }
    return stations;
};

export const getLaneDistance = (baseDistance, laneIndex) => {
    // Lane 1 is baseDistance.
    // Standard lane width is 1.22m.
    // Formula for extra distance per lap per lane: 2 * pi * width * (lane - 1)
    // 2 * PI * 1.22 ~= 7.665 meters per lane per lap.
    if (laneIndex === 1) return baseDistance;
    const laneOffset = 7.665;
    return baseDistance + (laneIndex - 1) * laneOffset;
};
